let cacheHasLocalStorage = null;

// See https://stackoverflow.com/questions/16427636/check-if-localstorage-is-available
function testLocalStorage() {
    const testKey = 'testkey';
    try {
        localStorage.setItem(testKey, 'testvalue');
        localStorage.removeItem(testKey);
        return true;
    } catch (e) {
        return false;
    }
}

export function hasLocalStorage() {
    if (cacheHasLocalStorage === null) {
        cacheHasLocalStorage = testLocalStorage();
    }
    return cacheHasLocalStorage;
}